import $ from 'jquery';


/* Panel
********************************************/


if ($('.js-replace-video').length) {
	$('.js-replace-video').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		$this.closest('.video-container').addClass('is-active');
		$this.siblings()[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
	});
}
